import useResponseHandler from "../responses/responseHandler";
import useAxios from "./httpConfigService";

const useHttp = () => {

  const axios = useAxios();
  const { handleError } = useResponseHandler();

  const send = async(method, url, data) => {
    try {
      const pathUrl = `/${url.replace(/^\/*/, '')}`; // we add the '/', so trim any from start of the url
      const response = await axios.request({
        method: method,
        url: pathUrl,
        data: data
      });
      return response.data;
    }
    catch(error) {
      handleError(error);
      throw error;
    }
  };

  // used for raw http calls where we do not want to manipulate the url
  // or headers collection (e.g., making 'PUT' call to cloud storage)
  const request = async(config) => {
    try {
      const response = await axios.request(config);
      return response.data;
    }
    catch(error) {
      handleError(error);
      throw error;
    }
  };

  const get = async (url) => await send('get', url);

  const post = async (url, data) => await send('post', url, data);

  const put = async (url, data) => await send('put', url, data);

  return { get, post, put, request };
};

export { useHttp };